import axios from 'axios';
import { ChangeUserSettings } from 'models/request';
import { changePasswordResponse, UserCompany } from 'models/response';
import { USERSERVICE } from 'utils/constants';
import { trackPromise } from 'react-promise-tracker';

/**
 * This API changes user's profile settings
 * @param {Object} body
 * @param {number} body.idUser
 * @param {string | null} body.base64Image
 * @param {0 | 1} body.flagUpdateImage
 * @param {UserDate} body.preferredDateFormat
 * @param {UserDecimalSep} body.decimalSeparator
 * @param {0 | 1} body.sendMail
 * @param {UserCsvSep} body.csvSeparator
 * @param {boolean} body.openNextDocument
 * @param {boolean} body.openInvoiceLogAutomatically
 * @param {boolean} body.openPreviousApprover
 *
 * @return {Promise<AxiosResponse>}
 */
const changeUserSettings = (body: ChangeUserSettings) => axios.post(`${USERSERVICE}/changeUserSettings`, { ...body });

/**
 * This API returns a list of configurations for the user
 * and active program, grouped by companies
 * @param {number} idUser
 * @param {number} idProgram
 * @return {Promise<AxiosResponse<UserCompany[]>>}
 */
const getConfigurationsByCompanies = (idUser: number, idProgram: number) =>
  trackPromise(
    axios.post<UserCompany[]>(`${USERSERVICE}/getUserCompanies`, {
      idUser,
      idProgram,
    }),
    'module',
  );

/**
 * This API allows the user to change the password
 * @param {number} idUser
 * @param {string} oldPassword
 * @param {string} newPassword
 * @return {Promise<AxiosResponse<changePasswordResponse>>}
 */

const changePassword = (idUser: number, oldPassword: string, newPassword: string) =>
  trackPromise(
    axios.post<changePasswordResponse>(`${USERSERVICE}/changePassword`, { idUser, oldPassword, newPassword }),
    'modal',
  );

/**
 * This API allows the user to rest the password
 * @param {string} email
 * @return {Promise<AxiosResponse<string>>}
 */

const resetPassword = (email: string) =>
  trackPromise(axios.post<string>(`${USERSERVICE}/resetPassword`, { email }), 'modal');

export default {
  getConfigurationsByCompanies,
  changeUserSettings,
  changePassword,
  resetPassword,
};
